import { render } from "./PatientSearchResults.vue?vue&type=template&id=6204f731&scoped=true&lang=pug"
import script from "./PatientSearchResults.vue?vue&type=script&lang=js"
export * from "./PatientSearchResults.vue?vue&type=script&lang=js"

import "./PatientSearchResults.vue?vue&type=style&index=0&id=6204f731&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6204f731"]])

export default __exports__